export default "__VITE_ASSET__C$yM6a6c__"